<template>
  <ts-card>
    <div
      class="
        form-header
        ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative
      "
    >
      <h4 class="ts-text-sm">
        {{
          $t('school.academic.operation.profile_mgt.studentProfile.previewCard')
        }}
      </h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <div id="container">
        <i class="fa fa-spinner spin fa-3x" v-if="printing"></i>
        <iframe :src="src" v-if="!printing"></iframe>
      </div>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
export default {
  name: 'previewCard',
  props: {
    id_list: {
      type: Array,
    },
    side: {
      type: String,
    },
    print_date: {
      type: String,
    },
  },
  data() {
    return {
      printing: false,
      src: '',
    }
  },
  created() {
    this.previewCard()
  },
  methods: {
    previewCard() {
      this.printing = true
      this.$store
        .dispatch('studentProfile/printCard', {
          student_id_list: this.id_list,
          side: this.side,
          print_date: this.print_date,
        })
        .then((response) => {
          this.$toasted.success(response.message)
          this.printing = false
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.printing = false
        })
    },
  },
}
</script>

<style scoped>
#container {
  width: 100%;
  height: 70vh;
  background: rgb(93, 94, 95);
  text-align: center;
}
#container iframe {
  width: 100%;
  height: 70vh;
  border: 2px solid #acacac;
}
#container i {
  margin-top: 32vh;
  color: white;
}
</style>
